/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : ViewTicketAttachment.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import React, { useState } from "react";
import {
  Box,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
  Chip,
} from "@mui/material";
import ViewImageDialog from "../../../components/dialog-boxes/ViewImageDialogBox";
import CustomButtonV2 from "../../../components/customComponentsV2/common/button/CustomButtonV2";

function AttachmentList({ artefactDetails }) {
  const [open, setOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleView = (file) => {
    setSelectedFile(file);
    setOpen(true);
  };

  if (!artefactDetails || artefactDetails.length === 0) {
    return (
      <Typography sx={{ textAlign: "center", p: 2 }}>
        No attachments available
      </Typography>
    );
  }

  return (
    <>
      <List>
        {artefactDetails?.map((item, index) => {
          const fileName = item?.attachment_meta?.filename;
          const displayName =
            item?.attachment_meta?.attachment_meta || fileName;

          return (
            <ListItem
              key={index}
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                mb: 2,
              }}
              secondaryAction={
                fileName && (
                  <CustomButtonV2
                    variant="contained"
                    size="small"
                    btnName="View"
                    handleOnClick={() => handleView(fileName)}
                  />
                )
              }
            >
              <ListItemText
                primary={displayName || "No file"}
                secondary={
                  <Box display="flex" gap={1} mt={1}>
                    <Chip
                      label={item?.attachment_type || "Attachment"}
                      size="small"
                      sx={{ color: "26890D" }}
                    />
                    <Typography variant="caption">
                      {new Date(item?.created_at).toLocaleString()}
                    </Typography>
                  </Box>
                }
              />
            </ListItem>
          );
        })}
      </List>

      {/* Dialog */}
      <ViewImageDialog
        open={open}
        onClose={() => setOpen(false)}
        fileName={selectedFile}
      />
    </>
  );
}

export default AttachmentList;
